export type TransferSearchType = {
  accountId: string;
  actionCause: {
    transactionId?: string;
    campaignId?: string;
    customEventId?: string;
    internalEventName?: string;
    performedAt?: string;
  };
  cancelled: boolean;
  comment: string;
  createdAt: string;
  registeredOn: string;
  createdBy: string;
  expiredAt: string;
  expiresAt: string;
  performedAt: string;
  lockedUntil: string;
  member: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    loyaltyCardNumber: string;
  };
  owner: {};
  unlockedAt: string;
  pending: boolean;
  relatedTransferId: string;
  storeId: string;
  transferId: string;
  type: "adding" | "p2p_adding" | "spending";
  value: number;
  walletType: {
    name: string;
    code: string;
    unitSingularName: string;
    unitPluralName: string;
  };
  externalTransferId?: string;
};

export type PointTransferPayload = {
  comment?: string;
  customer: string;
  expiresInDays?: number;
  lockedUntilDays?: number;
  points: number;
};

export enum PointsTransferTypes {
  SPEND_POINTS = "spendPoints",
  ADD_POINTS = "addPoints",
}

export type PointsTransferTypesUnion = `${PointsTransferTypes}`;

export type UnitTransferModal = {
  transfer: string;
  mode: number;
};
